"use client";
import Link from "next/link";

import Slider from "react-slick";
import { useRef } from "react";
import { APP_NAME } from "@/utils/enum";
import { useRouter } from "next/navigation";

const BLockFeatureTwo = ({ data, style }: any) => {
  const router = useRouter();
  const setting = {
    infinite: data.length > 3,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "0",
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  const sliderRef = useRef<Slider | null>(null);

  const handlePrevClick = () => {
    if (sliderRef.current) {
      sliderRef.current.slickPrev();
    }
  };

  const handleNextClick = () => {
    if (sliderRef.current) {
      sliderRef.current.slickNext();
    }
  };

  const firstFourEvent = data.slice(0, 4);
  return (
    <div className="bg-[#F5F5FF]">
      <div
        className=""
        style={{
          backgroundColor: "#F5F5FF",
          margin: "1%",
          borderRadius: "1rem",
          border: "1px solid rgba(0, 0, 0, 0.1)",
        }}
      >
        <div style={{ padding: "17px" }}>
          <div className="">
            <div
              className="d-flex flex-column flex-md-row justify-content-between 
            align-items-center align-items-lg-center gap-2"
            >
              <div>
                {style ? (
                  <h3>
                    <span
                      style={{
                        fontWeight: "400",
                        fontSize: "2.5rem",
                        font: "Graphik",
                      }}
                    >
                      {process.env.NEXT_PUBLIC_APP_NAME === APP_NAME.VIBGYOR_ONE
                        ? "Popular Activity"
                        : "Popular Events"}
                    </span>
                  </h3>
                ) : (
                  <h3>Popular Events</h3>
                )}
              </div>
              <div className="section-btn text-center pb-3">
                {process.env.NEXT_PUBLIC_APP_NAME !== APP_NAME.VIBGYOR_ONE && (
                  <button
                    className="primary-button"
                    type="submit"
                    style={{
                      display: "flex",
                      border: "none",
                      fontSize: "14px",
                      maxHeight: "40px",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "40px",
                      padding: "10px 20px",
                      cursor: "pointer",
                      width: "fit-content",
                    }}
                    onClick={() => {
                      router.push("/events");
                    }}
                  >
                    View All
                  </button>
                )}
              </div>
            </div>

            <div className="position-relative">
              <Slider
                {...setting}
                ref={sliderRef}
                className="property-location-slider-one"
              >
                {data?.map((item: any) => (
                  <div key={item.id} className="item-first">
                    <div className="rounded-image-container">
                      <div
                        className="rounded-image"
                        style={{
                          backgroundImage: `url("${item.Image_Path}")`,
                        }}
                      >
                        <div className="content text-center w-100 tran3s"></div>
                        <Link
                          href={item?.URL || "/"}
                          className="stretched-link"
                        ></Link>
                      </div>
                    </div>
                    <h5 className="fw-normal text-center mt-10">
                      {item.Title}
                    </h5>
                  </div>
                ))}
              </Slider>
              <ul
                className="slider-arrows slick-arrow-one style-none position-absolute top-50 start-0 w-100 d-flex justify-content-between align-items-center"
                style={{ transform: "translateY(-96%)", zIndex: 2 }}
              >
                <li
                  onClick={handlePrevClick}
                  className=" d-flex justify-content-center align-items-center bg-white rounded-circle"
                  style={{
                    width: "40px",
                    height: "40px",
                    boxShadow: "-3px 3px 1rem",
                    cursor: "pointer",
                  }}
                >
                  <i className="fa-sharp fa-light fa-angle-left"></i>
                </li>
                <li
                  onClick={handleNextClick}
                  className="carousel-control next_a slick-arrow d-flex justify-content-center align-items-center bg-white rounded-circle"
                  style={{
                    width: "40px",
                    height: "40px",
                    boxShadow: "3px 3px 1rem",
                    cursor: "pointer",
                  }}
                >
                  <i className="fa-sharp fa-light fa-angle-right"></i>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BLockFeatureTwo;
